import { post, get, patch, deleted } from '..';
import routes from './routes';

const InvoiceServices = {
  importInvoice: async (obj) => {
    const data = await post(routes.importInvoice, obj);
    return data;
  },
  createInvoice: async (obj) => {
    const data = await post(routes.createInvoice, obj);
    return data;
  },
  getInvoices: async (params) => {
    const data = await get(routes.getInvoices, params);
    return data;
  },
  getInvoiceById: async (id) => {
    const data = await get(routes.getInvoiceById + id);
    return data;
  },
  updateInvoice: async (id, obj) => {
    const data = await patch(routes.updateInvoice + id, obj);
    return data;
  },
  deleteInvoice: async (id) => {
    const data = await deleted(routes.deleteInvoice + id);
    return data;
  },
  validateInvoice: async (obj) => {
    const data = await post(routes.validateInvoice, obj);
    return data;
  },
  submitInvoice: async (obj) => {
    const data = await post(routes.submitInvoice, obj);
    return data;
  },
  exportInvoices: async (params) => {
    const data = await get(routes.exportInvoices, params, 'blob');
    return data;
  },
}

export default InvoiceServices